import React, {HTMLProps, MouseEventHandler, useCallback, useEffect, useState} from 'react';
import {log} from 'common/log';
import {useDispatch, useSelector} from 'react-redux';
import {selModalStateGen} from 'module/Modal/selector/ModalSelector';
import {ModalKey} from 'module/Modal/type/ModalKey';
import {modalSetPosSizeAction} from 'module/Modal/action/ModalAction';

interface Args {
	modalKey: ModalKey
	resizeLeft?: boolean
	defaultWidth?: number
	minWidth?: number
	maxWidth?: number
}

export function useHorizontalResize(args: Args) {
	const {modalKey, resizeLeft = false, defaultWidth = 270, minWidth = 30, maxWidth = document.body.offsetWidth} = args
	const dispatch = useDispatch()
	const [resizing, setResizing] = useState(false)
	const persistedWidth = useSelector(selModalStateGen(modalKey)).size?.width
	const [width, setWidth] = useState<number | undefined>(undefined)

	const onMouseMove = useCallback((e: MouseEvent) => {
		let w = resizeLeft ? (document.body.offsetWidth - e.clientX || minWidth) : (e.clientX || minWidth)
		if (w > maxWidth) w = maxWidth
		else if (w < minWidth) w = minWidth
		setWidth(w)
		log.trace(document.body.offsetWidth, e.clientX, w)
	}, [resizeLeft, minWidth, maxWidth])
	const onMouseUp = useCallback((e: MouseEvent) => {
		setResizing(false)
		log.trace('resize=false')
	}, [])
	useEffect(() => {
		const disable = () => {
			document.body.removeEventListener('mousemove', onMouseMove)
			document.body.removeEventListener('mouseup', onMouseUp)
		}
		if (resizing) {
			document.body.addEventListener('mousemove', onMouseMove)
			document.body.addEventListener('mouseup', onMouseUp)
		} else disable()
		return disable
	}, [resizing, onMouseMove, onMouseUp])
	const onMouseDown: MouseEventHandler = useCallback((e) => {
		if (e.button !== 0) return;
		setResizing(true)
		log.trace('resize=true')
	}, [])

	useEffect(() => {
		const tid = setTimeout(() => {
			if (!resizing && width) {
				const size = width === defaultWidth ? undefined : {width}
				dispatch(modalSetPosSizeAction({modalKey, size}))
			}
		}, 400)
		return () => clearTimeout(tid)
	}, [modalKey, width, resizing, defaultWidth])

	const ResizeHandle = useCallback((props: HTMLProps<HTMLDivElement>) => <div
		{...props}
		style={{cursor: 'e-resize', userSelect: 'none', ...props.style}}
		onMouseDown={onMouseDown}
	/>, [onMouseDown, onMouseMove, onMouseUp])
	return {width: Math.min(width || persistedWidth || defaultWidth, maxWidth), ResizeHandle}
}